var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountAndProjectManagement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.207,
    height: 23.158,
    viewBox: "0 0 29.207 23.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7865",
    "data-name": "Group 7865",
    transform: "translate(0.132 0.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M29.241,16.894a5.458,5.458,0,0,0-3.255-3.742,5.577,5.577,0,0,0-4.557.216,7.081,7.081,0,0,0-8.1-3.742,6.934,6.934,0,0,0-5.425,7.2A5.474,5.474,0,0,0,9.493,27.545h1.23a4.618,4.618,0,0,1-.217-1.439H9.493a3.889,3.889,0,0,1-4.051-3.742A3.855,3.855,0,0,1,8.77,18.046l.723-.144-.072-.72a5.406,5.406,0,0,1,4.268-6.261,5.443,5.443,0,0,1,1.519-.144,5.406,5.406,0,0,1,5.281,3.814l.289.936.8-.576a4.019,4.019,0,0,1,3.906-.5,3.906,3.906,0,0,1,2.459,3.095l.072.432.434.144a3.863,3.863,0,0,1,2.966,4.462,3.97,3.97,0,0,1-4.051,3.526h-.94a4.618,4.618,0,0,1-.217,1.439h1.23a5.377,5.377,0,0,0,5.425-4.822A5.294,5.294,0,0,0,29.241,16.894Z",
    transform: "translate(-3.983 -9.434)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    "data-name": "Group 1241",
    transform: "translate(7.838 9.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M21.641,23a6.641,6.641,0,1,0,6.641,6.641A6.613,6.613,0,0,0,21.641,23Zm0,11.806a5.165,5.165,0,1,1,5.165-5.165A5.134,5.134,0,0,1,21.641,34.806Z",
    transform: "translate(-15 -23)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M23.69,28H22.214v2.214H20V31.69h2.214V33.9H23.69V31.69H25.9V30.214H23.69Z",
    transform: "translate(-16.31 -24.31)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountAndProjectManagement);
export default __webpack_public_path__ + "static/media/account-and-project-management.a5022b887a617e6ae5e68dedf1195b4e.svg";
export { ForwardRef as ReactComponent };